import {theme} from '@styles/theme';
import styled from 'styled-components';

export const AuthPageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background-color: ${theme.colors.basic07};
`;

export const AuthPageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.basic08};
  border: 1px solid ${theme.colors.basic06};
  border-radius: ${theme.roundedBig};
`;

export const AuthPageMainContentWrapper = styled.div`
  width: 280px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;

export const AuthPageBottomContentWrapper = styled.div`
  border-top: 1px solid ${theme.colors.basic06};
  padding: 24px 0;
  display: flex;
  justify-content: center;
`;

export const AuthPageFieldsWrapper = styled.div`
  display: flex;
  width: 280px;
  flex-direction: column;
  gap: 16px;
`;

export const AuthPageErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: ${theme.roundedMedium};
  background-color: ${theme.colors.signalRed01};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
